export default __webpack_public_path__ + "static/create-flag-light-86e29f30a0cc6d40595a19172c6f2d3b.png";